import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Col, Form, FormGroup, Input, Label } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import { Btn, H2, Image, P } from '../AbstractElements';
import { dynamicImage } from '../Utils';
import { useSignIn } from './hooks/useSignIn';
import {
  EmailAddress,
  Password,
  RememberPassword,
  SignIn,
  SignInAccount,
  DontHaveAccount,
  CreateAccount,
} from '../Utils/Constants';

interface SignInFormValues {
  email: string;
  password: string;
}

export default function SignInForm() {
  const navigate = useNavigate();
  const { handleSignIn, loading } = useSignIn();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<SignInFormValues>();

  const onSubmit = (data: SignInFormValues) => {
    // alert(JSON.stringify(data));
    handleSignIn(data);
  };

  return (
    <div>
      <div>
        <Link className="logo" to={``}>
          <Image
            height={50}
            className="for-light"
            src={dynamicImage(`logo/divine_comedy.webp`)}
            alt="looginpage"
          />
          <Image
            height={50}
            className="for-dark"
            src={dynamicImage(`logo/divine_comedy.webp`)}
            alt="looginpage"
          />
        </Link>
      </div>

      <div className="login-main">
        <Form className="theme-form" onSubmit={handleSubmit(onSubmit)}>
          <H2 className="text-center">{SignInAccount}</H2>
          <P className="text-center">Enter your email & password to login</P>

          {/* Email */}
          <FormGroup>
            <Col>
              <Label>{EmailAddress}</Label>
            </Col>
            <Controller
              name="email"
              control={control}
              rules={{
                required: 'Email is required',
                pattern: {
                  value: /^\S+@\S+$/i,
                  message: 'Invalid email format',
                },
              }}
              render={({ field }) => <Input type="email" {...field} />}
            />
            {errors.email && (
              <P className="text-danger">{errors.email.message}</P>
            )}
          </FormGroup>

          {/* Password */}
          <FormGroup>
            <Col>
              <Label>{Password}</Label>
            </Col>
            <Controller
              name="password"
              control={control}
              rules={{
                required: 'Password is required',
                minLength: {
                  value: 6,
                  message: 'Password must be at least 6 characters',
                },
              }}
              render={({ field }) => <Input type="password" {...field} />}
            />
            {errors.password && (
              <P className="text-danger">{errors.password.message}</P>
            )}
          </FormGroup>

          {/* Remember checkbox + Submit */}
          <FormGroup className="mb-0 checkbox-checked">
            {/* <FormGroup className="checkbox-solid-info" check>
              <Input id="checkbox1" type="checkbox" />
              <Label htmlFor="checkbox1" check>
                {RememberPassword}
              </Label>
            </FormGroup> */}
              <Link to={`/forgot-password`}>{'Forgot password?'}</Link>

            <div className="text-end mt-3">
              <Btn
                type="submit"
                style={{
                  backgroundImage:
                    'linear-gradient(223deg, #FFAF00 45%, #FF3500 100%)',
                }}
                className="w-100"
                block
                disabled={loading}
              >
                {loading ? 'Signing In...' : SignIn}
              </Btn>
            </div>
          </FormGroup>

          {/* Create account link */}
          <P
            style={{ color: '#ff7a18' }}
            className="mt-4 mb-0 text-center"
          >
            {DontHaveAccount}
            <Link className="ms-2" to={`/register`}>
              {CreateAccount}
            </Link>
          </P>
        </Form>
      </div>
    </div>
  );
}
